import { bindingMode, processContent, autoinject, computedFrom } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { moveRulesToHelperSlot } from 'app/shared/elements/ess-rule';
import { AnimationFrameService } from 'app/shared/services/event-services';
import { InputBase } from 'app/shared/elements/forms/input-base';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { I18N } from 'aurelia-i18n';

@autoinject()
@processContent(moveRulesToHelperSlot)
export class EssTextareaCustomElement extends InputBase {

    @bindable.stringNull({ defaultBindingMode: bindingMode.twoWay })
    public value: string | null = null;

    @bindable.stringNull()
    public label: string | null = null;

    @bindable.stringNull()
    public requiredValidatorLabel: string | null = null;

    @bindable.string()
    public testName: string = '';

    @bindable.numberNull()
    public maxlength: number | null = null;

    @bindable.stringNull()
    public labelledbyId: string | null = null;  //An element's `id`. Sets the component's `aria-labelledby`

    protected isQueuedForResize = false;
    protected triggerResize = () => {
        if(this.isQueuedForResize === true) {
            this.isQueuedForResize = false;
            this.resize();
        }
    }

    protected $inputElement!: HTMLInputElement;
    protected $dummyElement!: HTMLInputElement;

    constructor(private readonly i18n: I18N,
        protected frameService: AnimationFrameService,
        ...rest: [Element, AppLogger]) {
        super(...rest);
    }

    protected attached() {
        this.frameService.addEventListener('frame', this.triggerResize);
    }

    protected detached() {
        this.frameService.removeEventListener('frame', this.triggerResize);
    }

    @computedFrom('label', 'requiredValidatorLabel')
    protected get requiredValueMessage() {
        return this.requiredValidatorLabel || this.i18n.tr('ui:validation:required', { what: this.i18n.tr(this.label || 'ui:labels.value') });
    }

    protected valueChanged(): void {
        this.isQueuedForResize = true;
    }

    protected resize() {
        this.$dummyElement.style.height = this.$inputElement.style.height;

        this.$inputElement.style.height = 'auto';
        this.$inputElement.style.height = `${this.$inputElement.scrollHeight + 1}px`;

        this.$dummyElement.style.height = `0px`;
    }
}
